
import { Vue } from "vue-class-component";

export default class PrintSummary extends Vue {}
